import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAdminLanguage } from '../AdminLanguageContext';
import { CLIENT_URL } from '../config';
import './Layout.css';

export { CLIENT_URL };

const NAV = [
  { groupKey: 'overview', items: [
    { to: '/', icon: '▦', labelKey: 'dashboard' },
    { to: '/analytics', icon: '∿', labelKey: 'analytics' },
  ] },
  { groupKey: 'management', items: [
    { to: '/users', icon: '◉', labelKey: 'users' },
    { to: '/sellers', icon: '✓', labelKey: 'sellers' },
    { to: '/services', icon: '▤', labelKey: 'services' },
    { to: '/orders', icon: '▣', labelKey: 'orders' },
    { to: '/support-messages', icon: '✉', labelKey: 'supportMessages' },
  ] },
  { groupKey: 'finance', items: [
    { to: '/refunds', icon: '↺', labelKey: 'refunds' },
    { to:  '/disputes', icon: '⚑', labelKey: 'disputes' },
    { to: '/reports', icon: '⚠', labelKey: 'reports' },
    { to: '/withdrawals', icon: '$', labelKey: 'withdrawals' },
  ] },
  { groupKey: 'system', items: [
    { to: '/categories', icon: '▦', labelKey: 'categories' },
    { to: '/settings', icon: '⚙', labelKey: 'settings' },
  ] },
];

export default function Layout({ children }) {
  const navigate = useNavigate();
  const { language, copy, setLanguage } = useAdminLanguage();
  const layoutCopy = copy.layout;
  const [collapsed, setCollapsed] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    navigate('/login');
  };

  return (
    <div className={`layout ${collapsed ? 'collapsed' : ''}`}>
      <aside className="sidebar">
        <div className="sidebar-logo">
          <span className="logo-text">{collapsed ? 'O' : layoutCopy.product}</span>
        </div>
        <nav className="sidebar-nav">
          {NAV.map(group => (
            <div className="nav-group" key={group.groupKey}>
              {!collapsed && <div className="nav-group-label">{layoutCopy.groups[group.groupKey]}</div>}
              {group.items.map(n => (
                <NavLink key={n.to} to={n.to} end={n.to === '/'} className={({isActive}) => `nav-item ${isActive ? 'active' : ''}`}>
                  <span className="nav-icon">{n.icon}</span>
                  {!collapsed && <span className="nav-label">{layoutCopy.nav[n.labelKey]}</span>}
                </NavLink>
              ))}
            </div>
          ))}
        </nav>
        <div className="sidebar-footer">
          <button className="nav-item" onClick={() => setCollapsed(c => !c)}>
            <span className="nav-icon">{collapsed ? '→' : '←'}</span>
            {!collapsed && <span className="nav-label">{collapsed ? layoutCopy.expand : layoutCopy.collapse}</span>}
          </button>
          <button className="nav-item logout-btn" onClick={handleLogout}>
            <span className="nav-icon">🚪</span>
            {!collapsed && <span className="nav-label">{layoutCopy.logout}</span>}
          </button>
        </div>
      </aside>
      <main className="main">
        <div className="topbar">
          <div className="topbar-title">{layoutCopy.title}</div>
          <div className="topbar-actions">
            <div className="admin-language-switch" aria-label={layoutCopy.language}>
              <button
                type="button"
                className={language === 'zh' ? 'active' : ''}
                onClick={() => setLanguage('zh')}
              >
                中文
              </button>
              <button
                type="button"
                className={language === 'en' ? 'active' : ''}
                onClick={() => setLanguage('en')}
              >
                EN
              </button>
            </div>
            <a href={CLIENT_URL} target="_blank" rel="noreferrer" className="topbar-link">
              {layoutCopy.visitClient} →
            </a>
          </div>
        </div>
        <div className="content">{children}</div>
      </main>
    </div>
  );
}
